import { inViewMargin } from '@helpers/animate';
import { imageUrl, srcSet } from '@helpers/image';
import { Device, from } from '@helpers/media';
import { useInView } from '@hooks/useInView';
import LinkButton from '@stories/Components/LinkButton/LinkButton';
import * as React from 'react';
import S from './CtaSection.styles';
const CtaSection = ({ content, cta, id, image, tint = 0.3, title }) => {
    const [refContainer, inView] = useInView({ rootMargin: inViewMargin });
    return (React.createElement(S.Container, { ref: refContainer, id: id, "data-inview": inView, style: { '--tintAmount': tint } },
        React.createElement(S.Inner, null,
            image && (React.createElement(S.ImageWrapper, null,
                React.createElement("picture", null,
                    React.createElement("source", { media: from(Device.Desktop), srcSet: srcSet(image, { width: 2560, height: 695 }) }),
                    React.createElement("source", { media: from(Device.DesktopSmall), srcSet: srcSet(image, { width: 1365, height: 695 }) }),
                    React.createElement("source", { media: from(Device.Tablet), srcSet: srcSet(image, { width: 1279, height: 500 }) }),
                    React.createElement("source", { media: from(Device.MobileLarge), srcSet: srcSet(image, { width: 767, height: 375 }) }),
                    React.createElement(S.Image, { alt: image.altText, loading: "lazy", src: imageUrl(image, { width: 479, height: 350 }), srcSet: srcSet(image, { width: 479, height: 350 }) })))),
            React.createElement(S.ContentWrapper, null,
                title && React.createElement(S.Title, { id: title.replaceAll(/[\W_]+/g, '-').toLowerCase() }, title),
                content && React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: content } }),
                cta && (React.createElement(S.CtaWrapper, null,
                    React.createElement(LinkButton, { buttonType: "inverted", href: cta.url, target: cta.target }, cta.text)))))));
};
export default CtaSection;
